/// <reference path="./globals.d.ts" />

/*
[WBLS-CART] -- v1.1.02 (Modified to keep only add-to-cart functionality)
*/

let progress_thresholds = [
  {
        threshold_USD: 5000,
        message: "FREE SHIPPING",
        label: "free shipping<br>(U.S. only)",
        var_id: "none"
}, {
        threshold_USD: 10000,
        message: "a FREE ACCESSORY",
        label: `<span class="new-accessory-flag">exclusive  </span>mystery accessory`,
        var_id: 45779459932326
}
];
window.js_cart_incentives = progress_thresholds;

// assuming free shipping is the first threshold
let free_shipping_threshold = js_cart_incentives[0].threshold_USD;

window.active_currency_conversion_rate = 1;
window.active_currency = "USD";

if(window.location.href.indexOf("/en-ca") > -1){
  window.active_currency = "CAD"
  window.active_currency_conversion_rate = 1.35;
}

let current_cart_count = 0;
let added_quantity = 0;

// Function to build GWP items for checkout
const js_cart_build_gwp_items = async (cart) => {
  console.log("js_cart_build_gwp_items()");

  // If no cart is provided, fetch it
  if (!cart) {
    const response = await fetch('/cart.js');
    if (!response.ok) {
      console.error('Cannot retrieve cart data');
      return '';
    }
    cart = await response.json();
  }

  const subtotal = cart.items_subtotal_price;
  let gwp_checkout_params = "";

  // reset value
  window.gwp_items_to_add = [];
  window.gwp_items_to_add_ref = [];

  // Check for qualifying items in the cart
  for (let i = 0; i < window.gwp_qualifying_items.length; i++) {
    let gwp_qualifier_var_id = window.gwp_qualifying_items[i].var_id;
    let gwp_qualifier_threshold = 999999;

    if (!!window.gwp_qualifying_items[i].threshold) {
      gwp_qualifier_threshold = window.gwp_qualifying_items[i].threshold;
    }

    // Check if qualifying item is in cart or subtotal meets threshold
    const qualifyingItemInCart = cart.items.some(item => item.variant_id.toString() === gwp_qualifier_var_id);

    if (qualifyingItemInCart || subtotal >= gwp_qualifier_threshold) {
      let qty_of_gwp_qualifier = 1;

      if (subtotal < gwp_qualifier_threshold && qualifyingItemInCart) {
        // Find the quantity of the qualifying item
        const qualifyingItem = cart.items.find(item => item.variant_id.toString() === gwp_qualifier_var_id);
        qty_of_gwp_qualifier = qualifyingItem ? qualifyingItem.quantity : 1;
      }

      for (let ii = 0; ii < parseInt(qty_of_gwp_qualifier); ii++) {
        window.gwp_items_to_add.push(window.gwp_qualifying_items[i].gwp_id);
        window.gwp_items_to_add_ref.push(i);
      }
    }
  }

  // Build checkout params for GWP items
  for (let i = 0; i < window.gwp_items_to_add.length; i++) {
    let hidden_item_index = window.gwp_items_to_add[i];
    let gwp_var_id = window.hidden_products[hidden_item_index].var_id;
    let qty_to_add = 1;

    gwp_checkout_params += `items[][id]=${gwp_var_id}&items[][quantity]=${qty_to_add}&`;

    if (window.gwp_qualifying_items[window.gwp_items_to_add_ref[i]].threshold) {
      gwp_checkout_params += `items[][properties][${encodeURIComponent("_free at threshold")}]=${parseInt(window.gwp_qualifying_items[window.gwp_items_to_add_ref[i]].threshold) / 100}&`;
    }
  }

  return gwp_checkout_params;
};

const retrieve_cart_data = () => {
  console.log("retrieve_cart_data()");

  // Capture snapshots BEFORE the AJAX call
  const expectedDelta = added_quantity;
  const expectedStart = current_cart_count;

  return Woobles.Sentry.startSpan({ name: 'Retrieve Cart Data' }, async () => {
    try {
      Woobles.Sentry.addInfoBreadcrumb({
        message: 'Retrieving cart data'
      })

      const response = await fetch('/cart.js')

      if (response.ok) {
        const cart = await response.json()

        window.active_currency = cart.currency;

        let cart_data = {
          cart_attributes: cart.attributes,
          cart_currency: cart.currency,
          cart_item_count: cart.item_count,
          cart_line_items: cart.items,
          cart_original_price: cart.original_total_price,
          cart_subtotal: cart.items_subtotal_price,
          cart_total_discount: cart.total_discount,
          cart_total_price: cart.total_price,
        };

        Woobles.Sentry.addBreadcrumb({
          message: 'Cart retrieved',
          data: {
            response: cart
          }
        })

        if(JSON.stringify(cart_data) != window.sessionStorage.getItem("local-cart-data")){
          console.log("CHANGES TO CART - UPDATE LOCAL CART DATA");
          window.sessionStorage.setItem("local-cart-data", JSON.stringify(cart_data));

          // send cart data to Klaviyo (function defined in theme)
          if (typeof kl_tracking_atc === 'function') {
            kl_tracking_atc(cart);
          }
        } else {
          console.log("NO CHANGES - PRESERVE LOCAL CART DATA");
        }

        // Check to see if items were added to cart and assert whether the new quantity matches what is returned
        // from the cart
        if (expectedDelta > 0) {
          if (expectedStart + expectedDelta !== cart.item_count) {
            Woobles.Sentry.addErrorBreadcrumb({
              message: `${expectedDelta} items were added to cart which had ${expectedStart} in it, but only ${cart.item_count} are in the cart now`,
              data: {
                cart: cart
              }
            })
            Woobles.Sentry.captureException(new Error('Cart item count does not match expected value'));
          }

          added_quantity = 0
        }

        current_cart_count = cart.item_count;

        return cart
      } else {
        Woobles.Sentry.captureException(new Error('Cannot retrieve cart data'));
      }
    } catch (error) {
      Woobles.Sentry.captureException(error);
      console.error('Error fetching cart:', error);
    }
  })
};

// Function to add free shipping threshold property to the cart
const add_free_shipping_threshold = async (cart) => {
  try {
    // If no cart is provided, fetch it
    if (!cart) {
      const response = await fetch('/cart.js');
      if (!response.ok) {
        throw new Error('Cannot retrieve cart data');
      }
      cart = await response.json();
    }

    // If cart is empty, return
    if (cart.items.length === 0) {
      return;
    }

    // Get the last item in the cart
    const lastItem = cart.items[cart.items.length - 1];

    // Add the free shipping threshold property to the last item
    const updateResponse = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: lastItem.key,
        quantity: lastItem.quantity,
        properties: {
          ...lastItem.properties,
          "_free shipping threshold": free_shipping_threshold / 100
        }
      }),
    });

    if (!updateResponse.ok) {
      throw new Error('Cannot update cart with free shipping threshold');
    }

    console.log('Added free shipping threshold property to cart');
    return await updateResponse.json();
  } catch (error) {
    console.error('Error adding free shipping threshold:', error);
    Woobles.Sentry.captureException(error);
  }
};

const set_atc_loading_state = (button, isLoading = false) => {
  if (!button) return

  const text = button.querySelector('[data-add-to-cart-text]')
  const loader = button.querySelector('[data-loader]')

  button.toggleAttribute('aria-disabled', isLoading)

  if (!text || !loader) return

  text.classList.toggle('hide', isLoading)
  loader.classList.toggle('hide', !isLoading)
}

const add_to_cart = (var_id, qty = 1, line_item_properties) => {
  const body = {
    id: parseInt(var_id),
    quantity: qty,
    properties: line_item_properties
  }

  return Woobles.Sentry.startSpan({ name: 'Add to Cart' }, async () => {
    try {
      Woobles.Sentry.addInfoBreadcrumb({
        message: 'Adding item to cart',
        data: {
          payload: body
        }
      })

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      })

      if (response.ok) {
        added_quantity = qty;

        const data = await response.json()

        console.log('Item added to cart:', data);

        document.dispatchEvent(new Event('cart:added'))

        Woobles.Sentry.addBreadcrumb({
          message: 'Item added to cart',
          data: {
            payload: body,
            response: data
          }
        })

        // After adding item to cart, add free shipping threshold property
        const updatedCart = await add_free_shipping_threshold();

        // If add_free_shipping_threshold returned a cart, use it directly
        if (updatedCart) {
          return updatedCart;
        } else {
          // Otherwise fetch the cart data
          const cartData = await retrieve_cart_data();
          return cartData;
        }
      } else {
        Woobles.Sentry.captureException(new Error('Cannot add item to cart'))
      }
    } catch (error) {
      Woobles.Sentry.captureException(error);
      console.error('Error adding item to cart:', error);
    }
  })
};

// Handle checkout button on cart page to process GWPs
if(window.location.href.indexOf(".com/cart") > -1){
  observeSelector('input[type="submit"][name="checkout"]', standard_checkout_btn => {
    standard_checkout_btn.addEventListener("click", async (e) => {
      e.preventDefault();

      // Get cart data
      const response = await fetch('/cart.js');
      if (!response.ok) {
        console.error('Cannot retrieve cart data');
        window.location.href = '/checkout'; // Fallback to standard checkout
        return;
      }

      const cart = await response.json();

      // Build GWP checkout params
      const gwp_checkout_params = await js_cart_build_gwp_items(cart);

      // Redirect to checkout with GWP items
      if (gwp_checkout_params) {
        window.location.href = `/cart/add?${gwp_checkout_params}return_to=/checkout`;
      } else {
        window.location.href = '/checkout';
      }
    });
  });
}

// handle atc button clicks
observeSelector('[data-add-to-cart], [class*="add-to-cart"]', atc_button => {
  atc_button.addEventListener("click", () => {
    set_atc_loading_state(atc_button, true);

    Woobles.Sentry.addClickBreadcrumb({
      message: 'Clicked Add to Cart - [data-add-to-cart]',
      data: {
        html: atc_button.outerHTML
      }
    })

    if(!!atc_button.getAttribute("data-add-to-cart")){
      let var_id = atc_button.getAttribute("data-add-to-cart");
      let props = {};

      for (key in atc_button.dataset) {
        if (key.startsWith('properties') && atc_button.dataset[key].split(":").length > 1) {
          const [prop_name, prop_value] = atc_button.dataset[key].split(":");
          props[prop_name.trim()] = prop_value.trim();
        }
      }

      add_to_cart(var_id, 1, props);
      setTimeout(() => {
        set_atc_loading_state(atc_button, false);
      }, 1000);
    } else {
      setTimeout(() => {
        retrieve_cart_data();
        set_atc_loading_state(atc_button, false);
      }, 500);
    }
  });
});

waitForElement('body').then(doc => {
  doc.insertAdjacentHTML("afterbegin", `
  <div id="js-shipping-banner" class="js-shipping-banner" style="
    background: #009bbf;
    padding: .5rem 1rem;
    color: #fff;
    font-weight: 500;
    text-align: center;
  ">🚚 Free Shipping for orders $${parseInt(js_cart_incentives[0].threshold_USD/100)}+</div>
  `);
}).catch(Woobles.Sentry.captureException);
